import '@/header/HeaderTabsContainer.less';
import React, { memo } from 'react';
import PrematchTipsContainerPending from '@/nikeone/components/PrematchTipsContainerPending';
import HeaderTabsContainer from '@/header/HeaderTabsContainer';
import { BackButton } from '@/common/components/HelperButtons';

export const PrematchEventDetailPending = memo(function PrematchEventDetailPending() {
    return (
        <>
            <EventDetailHeaderNavigationPending />
            <EventDetailTabsPending />
            <EventDetailPrematchBetsPending />
        </>
    );
});

export function EventDetailHeaderNavigationPending(showSubtitle) {
    return (
        <div className={'detail-event-prematch'} style={{ height: '70px' }}>
            <div className={'sticky'}>
                <BackButton otherClass={'btn-go-back-inversed'} />
                <div className="empty-space" />
                <EventDetailHeaderTitlePending />
                {showSubtitle && <EventDetailHeaderSubtitlePending />}
            </div>
        </div>
    );
}

function EventDetailHeaderTitlePending() {
    return (
        <div className="flex-center fs-12 py-10">
            <WaveAnimatedBg height={14} width="60%" />
        </div>
    );
}

function EventDetailHeaderSubtitlePending() {
    return (
        <div className="flex-center fs-14 text-bold pb-5">
            <WaveAnimatedBg height={20} width="75%" />
        </div>
    );
}

function EventDetailTabsPending() {
    return (
        <div className="event-detail-tabs-pending">
            <HeaderTabsContainer>
                <button className="tab-button active">
                    <StaticBg height={30} width={90} />
                </button>
                <button className="tab-button">
                    <StaticBg height={30} width={90} />
                </button>
                <button className="tab-button">
                    <StaticBg height={30} width={90} />
                </button>
            </HeaderTabsContainer>
        </div>
    );
}

function EventDetailAccordion({ children }) {
    return (
        <div className="accordion-pending">
            <div className="accordion-head-pending">
                <WaveAnimatedBg height={20} width="60%" />
            </div>
            <div className="accordion-content detail">{children}</div>
        </div>
    );
}

function WaveAnimatedBg({ width, height, borderRadius = 4, styles }) {
    const style = { width, height, borderRadius, ...styles };
    return <div className="wave-animation" style={style} />;
}

function StaticBg({ width, height, borderRadius = 4, styles }) {
    const style = { width, height, borderRadius, ...styles };
    return <div className="static-pending-bg" style={style} />;
}

function EventDetailPrematchBetsPending() {
    return (
        <div className="event-detail-bets-pending">
            <EventDetailAccordion>
                <PrematchTipsContainerPending />
                <PrematchTipsContainerPending />
            </EventDetailAccordion>
            <EventDetailAccordion>
                <PrematchTipsContainerPending />
            </EventDetailAccordion>
        </div>
    );
}
